import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'shalala';

import { useStore } from '../../../store';
import { Auth, Http, Event } from '../../../support';
import Table from '../../../facturotopia/table/Table';
import ColumnFactory from './utilities/ColumnFactory';
import ComprobantesItemStatus from './components/ComprobantesListItemStatus';

class ComprobantesList extends Component {
  state = {};

  constructor(props) {
    super(props);

    let columns = this.columns;
    let index = columns.findIndex((item) => item.key === 'emisor_razon_social');

    this.state = {
      columns: columns,
      include: index !== -1 ? 'emisor' : '',
      selectedRowKeys: [],
    };

    Event.on('app.refresh', this.handleOnAppNeedsRefresh);
  }

  componentDidMount() {
    const { data } = this.props.list;

    if (data.length === 0) {
      const from = moment().subtract(7, 'days').format('YYYY-MM-DD');
      const to = moment().format('YYYY-MM-DD');

      const { include } = this.state;

      this.paginate({
        include,
        page: 1,
        from,
        to,
      });
    }
  }

  componentWillUnmount() {
    Event.off('app.refresh', this.handleOnAppNeedsRefresh);
  }

  get columns() {
    const {
      empresa: { config = {} },
    } = Auth.getData() || {};
    let { columnas_factura = [] } = config;

    let columns = [
      {
        align: 'center',
        key: 'status',
        title: 'Status',
        dataIndex: 'status',
        render: (item) => <ComprobantesItemStatus data={item} />,
      },
      {
        key: 'version',
        title: 'Versión',
        dataIndex: 'version',
      },
      {
        key: 'timbrado_at',
        title: 'Fecha',
        dataIndex: 'timbrado_at',
      },
      {
        key: 'tipo',
        title: 'Tipo',
        dataIndex: 'tipo',
      },
      {
        key: 'emisor_rfc',
        title: 'Emisor',
        dataIndex: 'emisor_rfc',
      },
      {
        key: 'receptor_rfc',
        title: 'Receptor',
        dataIndex: 'receptor_rfc',
      },
      {
        key: 'metodo_de_pago',
        title: 'M. Pago',
        render: (item) => item.metadata?.MetodoPago,
      },
      {
        key: 'forma_de_pago',
        title: 'F. Pago',
        render: (item) => item.metadata?.FormaPago,
      },
      {
        key: 'total',
        title: 'Total',
        dataIndex: 'total',
      },
      {
        key: 'serie',
        title: 'Serie/Folio',
        render: (item) => {
          let column = '';

          if (!!item.serie && !!item.folio) {
            column = (
              <span>
                {item.serie}/{item.folio}
              </span>
            );
          } else if (!!item.serie && !item.folio) {
            column = <span>{item.serie}</span>;
          } else if (!item.serie && !!item.folio) {
            column = <span>{item.folio}</span>;
          } else {
            column = <span></span>;
          }

          return column;
        },
      },
      {
        key: 'uuid',
        title: 'Folio Fiscal',
        dataIndex: 'uuid',
      },
      {
        key: 'emisor_razon_social',
        title: 'R.S. Emisor',
        className: 'cell-small',
        render: (item) => item.emisor?.razon_social,
      },
      {
        key: 'receptor_razon_social',
        title: 'R.S. Receptor',
        className: 'cell-small',
        render: (item) => item.metadata?.ReceptorNombre,
      },
      {
        key: 'codigo',
        title: 'Código',
        dataIndex: 'codigo',
      },
    ];

    if (columnas_factura.length === 0) {
      let defaultColumns = columns.slice(0, 11);

      columnas_factura = defaultColumns.map((item) => {
        return item.key;
      });
    }

    return new ColumnFactory().apply(columns, columnas_factura);
  }

  handleOnAppNeedsRefresh = () => {
    this.paginate({ page: 1 });
  };

  paginate(meta = {}) {
    const { filters } = this.props.list;

    this.props.listActions.paginate({
      ...filters,
      ...meta,
    });
  }

  handleOnPageChange = (page) => {
    this.paginate({ page });
  };

  handleOnPageLimitChange = (limit) => {
    this.paginate({ limit, page: 1 });
  };

  handleRowSelectionChange = ({ selectedRowKeys, selectedRows }) => {
    this.setState(
      {
        selectedRows,
        selectedRowKeys,
      },
      () => {
        const { onRowSelectionChange } = this.props;

        onRowSelectionChange && onRowSelectionChange({ selectedRowKeys, selectedRows });
      }
    );
  };

  handleDownload = async (uuid) => {
    try {
      const response = await Http.get(`api/comprobantes/${uuid}`);

      window.location = response.data.link;
    } catch (error) {}
  };

  getRowSelectionConfig = () => {
    const { selectedRowKeys } = this.state;
    const { selectable } = this.props;

    if (!selectable) {
      return null;
    }

    return {
      type: 'checkbox',
      selectedRowKeys,
      onChange: this.handleRowSelectionChange,
      getCheckboxProps: (record) => ({
        disabled: record.name === 'Disabled User', // Column uration not to be checked
        name: record.name,
      }),
    };
  };

  getPaginationConfig() {
    const { pagination } = this.props.list;

    return {
      metadata: pagination,
      onPageChange: this.handleOnPageChange,
      onPageLimitChange: this.handleOnPageLimitChange,
    };
  }

  render() {
    const { columns } = this.state;
    const { onRowClick } = this.props;
    const { data, busy } = this.props.list;

    return (
      <Table
        loading={busy}
        columns={columns}
        rowKey={'id'}
        data={data}
        pagination={this.getPaginationConfig()}
        rowSelection={this.getRowSelectionConfig()}
        onRowClick={onRowClick}
      ></Table>
    );
  }
}

const mapState = (store) => {
  return { list: store.app.comprobantes.list };
};

const mapActions = (actions) => {
  return { listActions: actions.app.comprobantes.list };
};

export default connect(useStore, mapState, mapActions)(ComprobantesList);
